import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const LabelOrderRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.labelOrderList,
    children: [{ index: true, lazy: () => import('./label-order-list') }],
  },
];
